import React from 'react'
import { Provider } from 'react-redux'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import registerServiceWorker from './registerServiceWorker'
import configureStore from './store/configureStore'
import axios from 'axios'
import moment          from 'moment'
import momentLocalizer from 'react-widgets-moment'
import './styles/styles.css'

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

moment.locale('nl')
moment.fn.toJSON = function() { return this.format('YYYY-MM-DD[T]HH:mm:ss') } // Strip tijdzone
momentLocalizer(moment)

const store = configureStore()

const kcConfig = {
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  url: process.env.REACT_APP_KEYCLOAK_URL,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
};

const kc = new window.Keycloak(kcConfig)
kc.init({onLoad: 'check-sso'}).then(authenticated => {
  if (authenticated) {
    setInterval(() => {
      kc.updateToken(10).catch(() => kc.logout());
    }, 10000);

    ReactDOM.render(<Provider store={store}>
      <BrowserRouter>
        <App store={store} keycloakSession={kc} onLogout={()=>kc.logout()} />
      </BrowserRouter>
    </Provider>, document.getElementById('root'))

  } else {
    // show possibly other page here...
    kc.login()
  }
});

axios.interceptors.request.use(config => {
  config.headers = {...config.headers, ...{
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: 'Bearer ' + kc.token
  }};
  return config;
});

axios.interceptors.response.use(response => {
  return response
}, error => {
  if (error.status === 401) {
    kc.login()
  }
  return Promise.reject(error)
})

registerServiceWorker();
